import { getCompletitionData } from '@src/packages/utils/functions/triggers';

const mapTriggerAggregationBuckets = aggregation =>
  (aggregation?.triggersNested?.byTrigger?.buckets || []).map(bucket => ({
    id: bucket.key,
    expectedExecutions: bucket.expectedTriggerExecutions?.value || 0,
    finishedExecutions: bucket.cappedFinishedExecutions?.value ?? bucket.finishedTriggerExecutions?.value ?? 0,
  }));

/**
 * Derives schedule completion counts from Elasticsearch aggregation buckets.
 * Uses per-trigger caps (same rules as getCompletitionData) so totals align with
 * the progress percentage and with markings summaries in the timeline drawer.
 */
export const getScheduleAggregationCompletion = aggregation => {
  const triggers = mapTriggerAggregationBuckets(aggregation);

  const buckets = aggregation?.triggersNested?.byTrigger?.buckets || [];
  const cappedTotal = aggregation?.triggersNested?.cappedFinishedExecutions?.value;
  // The top-level metric caps before grouping executions and includes omitted terms buckets.
  const useTotals = cappedTotal != null || triggers.length === 0;
  const completion = getCompletitionData(useTotals ? [{
    expectedExecutions: aggregation?.triggersNested?.expectedExecutions?.value || 0,
    finishedExecutions: cappedTotal ?? aggregation?.triggersNested?.finishedExecutions?.value ?? 0,
  }] : triggers);

  // Legacy terms responses may omit required triggers. Keep the full denominator and
  // count only fulfilled requirements proven by the available buckets.
  const expectedTotal = aggregation?.triggersNested?.expectedExecutions?.value || 0;
  const totals = !useTotals && expectedTotal > completion.expectedExecutions
    ? getCompletitionData([{ expectedExecutions: expectedTotal, finishedExecutions: completion.finishedExecutions }])
    : completion;

  return {
    ...totals,
    triggers: buckets,
    status: totals.finishedPercentage < 100 ? 'active' : 'completed',
  };
};
